<script>
    let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        bottom: 93px;
        left: 10px;
        width: 288.08px;
        height: 16.47px;
    }

    text {
        font-size: 12px;
        font-weight: bold;
        font-family: AvenirNext-Regular, Avenir Next, sans-serif;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288.08 16.47">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <text {fill} transform="translate(2 10.25)">Schedule</text>
            <text {fill} transform="translate(200 10.25)">Teams</text>
        </g>
    </g>
</svg>
